import { useGradualRollout } from '../../commons/hooks/useGradualRollout';
import { billingPortalConfig } from '../../commons/config';

export const usePayAllFeatureSwitcher = () => {
  const { isEnabled } = useGradualRollout('pay-all', billingPortalConfig.payAllRolloutLevel);
  return {
    isEnabled: isEnabled && billingPortalConfig.payAllEnabled,
  };
};
